module.exports = __webpack_public_path__ + "static/bicycles-8a23ef0637668b28f78d951d37a51963.png";